import React, {Component} from "react";
import {FormField} from "../../../../components/form";
import {SelectInput, TextInput} from "../../../../components";
import {DialogActions} from "@material-ui/core";
import {Button} from "react-bootstrap";
import ValidationUtil from "../../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import InvoiceUpdateReasonEnum from "./enums/InvoiceUpdateReasonEnum";

export default class DelayReasonModal extends Component {

    constructor(props) {
        super(props);

        const invoice = props.invoice;
        let delayReason = "";
        let customText = "";

        if (invoice.delayReason) {
            delayReason = invoice.delayReason;
            if ((invoice.delayReason === 'OTHER' || invoice.delayReason === 'REFUND') && invoice.delayReasonOther) {
                customText = invoice.delayReasonOther;
            }
        }

        this.state = {
            delayReason: delayReason,
            customText: customText
        };
    }

    confirm() {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        const {invoice} = this.props;

        if ((this.state.delayReason === "OTHER" || this.state.delayReason === "REFUND") && (!this.state.customText || this.state.customText.trim() === "")) {
            ValidationUtil.showMessage("Please provide reason details", "error");
            return;
        }

        RemotingService.postRemoteCall(
            `api/billing/invoice/${invoice.id}/delay-reason`,
            {
                reason: this.state.delayReason,
                reasonOther: (this.state.delayReason === "OTHER" || this.state.delayReason === "REFUND") ? this.state.customText.trim() : null
            },
            (invoice) => {
                this.props.close();
                this.props.onSave(invoice);
            }
        );
    }

    render() {
        this.formFields = [];

        return (
            <>
                <div className="container padding-10" style={{width: '600px'}}>
                    <div className="row mt-1">
                        <div className="col-4 border">
                            <div>Reason:</div>
                        </div>
                        <div className="col-8 border">
                            <FormField ref={formField => this.formFields.push(formField)}
                                       required
                                       validateOn={this.state.delayReason}>
                                <SelectInput displayProperty="name" valueProperty="key" searchEnabled={false}
                                             value={this.state.delayReason}
                                             options={InvoiceUpdateReasonEnum.toArray()}
                                             onChange={(delayReason) => this.setState({
                                                 delayReason,
                                                 customText: (delayReason === "OTHER" || delayReason === "REFUND") ? this.state.customText : ""
                                             })}/>
                            </FormField>
                        </div>
                    </div>

                    {(this.state.delayReason === "OTHER" || this.state.delayReason === "REFUND") && (
                        <div className="row mt-1">
                            <div className="col-4 border">
                                <div>Details</div>
                            </div>
                            <div className="col-8 border">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required
                                           validateOn={this.state.customText}>
                                    <TextInput value={this.state.customText}
                                               onChange={(customText) => this.setState({customText})}
                                               placeholder="Please specify the details..."
                                               maxLength={500}
                                    />
                                </FormField>
                            </div>
                        </div>
                    )}
                </div>
                <DialogActions>
                    <Button variant="success" onClick={() => this.confirm()}>Confirm</Button>
                </DialogActions>
            </>
        );
    }

}